import { render, staticRenderFns } from "./deliverynote_print.vue?vue&type=template&id=2dc3dc36"
import script from "./deliverynote_print.vue?vue&type=script&lang=js"
export * from "./deliverynote_print.vue?vue&type=script&lang=js"
import style0 from "./deliverynote_print.vue?vue&type=style&index=0&id=2dc3dc36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports